var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRcmPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640.94 243.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a897fb;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-5 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-6 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-7 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-8 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-9 {\n        fill: #0c344a;\n        font-family: Calibri-Bold, Calibri;\n        font-size: 13.89px;\n        font-weight: 700;\n      }\n\n      .cls-10 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-11 {\n        letter-spacing: .01em;\n      }\n\n      .cls-2 {\n        fill: #6d66d2;\n      }\n\n      .cls-12 {\n        letter-spacing: 0em;\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-14, .cls-3 {\n        fill: #a6a6a6;\n      }\n\n      .cls-15 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-16 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-17 {\n        letter-spacing: .02em;\n      }\n\n      .cls-18 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-21 {\n        stroke-width: .13px;\n      }\n\n      .cls-21, .cls-22 {\n        stroke: #fff;\n        stroke-linejoin: round;\n      }\n\n      .cls-21, .cls-22, .cls-4, .cls-23, .cls-24 {\n        fill: none;\n      }\n\n      .cls-22 {\n        stroke-width: .33px;\n      }\n\n      .cls-25 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-26 {\n        letter-spacing: .01em;\n      }\n\n      .cls-27 {\n        letter-spacing: .01em;\n      }\n\n      .cls-28 {\n        letter-spacing: 0em;\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-30 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-31 {\n        letter-spacing: 0em;\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-33 {\n        letter-spacing: .01em;\n      }\n\n      .cls-34 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-35 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-36 {\n        letter-spacing: 0em;\n      }\n\n      .cls-37 {\n        letter-spacing: 0em;\n      }\n\n      .cls-24 {\n        stroke: #a6a6a6;\n        stroke-miterlimit: 10;\n        stroke-width: 2.11px;\n      }\n\n      .cls-38 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-39 {\n        letter-spacing: 0em;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "37.58 153.26 103.1 153.26 103.1 86.91 37.58 86.91 37.58 153.26 37.58 153.26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "150.84 154.29 216.35 154.29 216.35 87.94 150.84 87.94 150.84 154.29 150.84 154.29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "270.19 153.26 335.2 153.26 335.2 86.91 270.19 86.91 270.19 153.26 270.19 153.26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "374.3 154.29 439.82 154.29 439.82 87.94 374.3 87.94 374.3 154.29 374.3 154.29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "487.56 153.77 553.07 153.77 553.07 87.43 487.56 87.43 487.56 153.77 487.56 153.77"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Crop_Marks",
    "data-name": "Crop Marks"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(10.75 28.01) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 6.7,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 13.38,
    y: 0
  }, "ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 21.69,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 28.89,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 36.09,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 40.73,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 43.83,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 51.55,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 58.74,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 65.42,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 69.02,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 74.67,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 79.3,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 83.93,
    y: 0
  }, "at"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 90.62,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 98.93,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 106.13,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 113.33,
    y: 0
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(27.51 44.48) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&amp;"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 9.78,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 12.88,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 20.61,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 27.8,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 32.94,
    y: 0
  }, "ifi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 44.4,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 50.06,
    y: 0
  }, "at"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 56.75,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 64.56,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 72.26,
    y: 0
  }, "n")), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(131.49 199.31) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 8.23,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 15.44,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 20.07,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 27.77,
    y: 0
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 39.08,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 45.77,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 50.4,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 57.6,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 64.8,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 67.38,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 74.6,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 81.8,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 88.48,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 93.61,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 100.3,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 107.49,
    y: 0
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(134.54 215.76) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 7.21,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 13.9,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 21.1,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 25.73,
    y: 0
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 32.94,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 38.07,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 45.26,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 48.36,
    y: 0
  }, "&amp;"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 58.15,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 61.24,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 68.45,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 76.15,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 83.36,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 86.95,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 94.15,
    y: 0
  }, "g")), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(236.02 31.51) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AI-Powered Claims "), /*#__PURE__*/React.createElement("tspan", {
    x: 25.48,
    y: 16.66
  }, "Processing")), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(351.23 198.94) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Denial Management"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.52,
    y: 16.66
  }, "&amp; Reconciliation")), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(444.48 31.26) scale(.99 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Reporting &amp; Performance "), /*#__PURE__*/React.createElement("tspan", {
    x: 37.72,
    y: 16.66
  }, "Optimization")), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "0 243.77 0 0 640.94 0 640.94 243.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M99.5,133.77c.69,1.66,1.04,3.45,1.04,5.26,0,7.56-6.05,13.68-13.51,13.68s-13.51-6.13-13.51-13.68,6.05-13.68,13.51-13.68c3.68,0,7.2,1.52,9.75,4.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M87.03,145.35c-.55,0-1.08-.22-1.47-.62l-5.2-5.26c-.75-.88-.64-2.21,.23-2.97,.78-.67,1.92-.67,2.7,0l3.73,3.77,12.05-12.19c.87-.76,2.18-.65,2.93,.23,.67,.79,.67,1.95,0,2.74l-13.51,13.68c-.38,.4-.91,.62-1.47,.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M67.27,95.87c0,5.26-6.99,8.42-15.59,8.42v11.58c0,6.4,5.11,11.58,11.44,11.58s11.44-5.18,11.44-11.58v-11.58c-4.02,0-7.28-3.77-7.28-8.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M54.8,108.5c.8,.07,1.54,.45,2.08,1.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M71.43,108.5c-.8,.07-1.54,.45-2.08,1.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M51.68,112.71h6.91c.65,.02,1.28-.29,1.66-.84,.7-.86,1.76-1.34,2.86-1.26,1.1-.07,2.16,.4,2.86,1.26,.38,.55,1.01,.86,1.66,.84h6.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M74.55,115.87c0,1.16-5.11,2.11-11.44,2.11s-11.44-.95-11.44-2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M72.47,121.29c-3.08,.65-6.22,.96-9.36,.89-3.14,.06-6.28-.24-9.36-.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M51.68,116.92c-2.3,0-4.16-2.36-4.16-5.26,0-1.16,.94-2.11,2.08-2.11s2.08,.95,2.08,2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M74.55,116.92c2.3,0,4.16-2.36,4.16-5.26,0-1.16-.94-2.11-2.08-2.11s-2.08,.95-2.08,2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M77.67,109.56c1.04-2.11,2.08-5.35,2.08-11.58,0-5.26-3.25-8.42-7.28-8.42-1.6,0-3.16,.54-4.43,1.54-2.8-2.47-6.41-3.78-10.13-3.64-6.32,0-11.44,5.18-11.44,11.58,0,5.21,.79,8.18,2.08,10.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M58.96,127.45v2.11c0,1.16-.94,2.11-2.08,2.11h-14.55c-2.3,0-4.16,1.88-4.16,4.21v16.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 45.44,
    y1: 146.4,
    x2: 45.44,
    y2: 152.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 38.16,
    y1: 149.56,
    x2: 45.44,
    y2: 149.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M67.27,127.45v2.11c0,1.16,.94,2.11,2.08,2.11h6.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M70.39,131.66c0,2.33-3.25,4.21-7.28,4.21s-7.28-1.88-7.28-4.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M74.55,131.66c0,4.65-5.11,8.42-11.44,8.42s-11.44-3.77-11.44-8.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 80.79,
    y1: 152.71,
    x2: 80.79,
    y2: 151.66
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M153.91,152.21h28.66c.56,0,1.02-.47,1.02-1.04v-49.76c0-.57-.46-1.04-1.02-1.04h-28.66c-.56,0-1.02,.47-1.02,1.04v49.76c0,.57,.46,1.04,1.02,1.04h0Zm19.95-49.76l-.35,2.07h-10.54l-.35-2.07h11.24Zm-18.93,0h5.6l.54,3.29c.09,.51,.52,.87,1.02,.86h12.28c.5,.01,.93-.36,1.02-.86l.54-3.29h5.6v47.68h-26.62v-47.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M174.38,145.99h-12.28c-.56,0-1.02,.47-1.02,1.04s.46,1.04,1.02,1.04h12.28c.56,0,1.02-.47,1.02-1.04s-.46-1.04-1.02-1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M199.98,98.31c.56,0,1.02-.47,1.02-1.04v-6.22c0-.57-.46-1.04-1.02-1.04h-31.74c-.56,0-1.02,.47-1.02,1.04v6.22c0,.57,.46,1.04,1.02,1.04s1.02-.47,1.02-1.04v-5.18h29.69v5.18c0,.57,.46,1.04,1.02,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M213.29,100.38h-26.62c-.56,0-1.02,.47-1.02,1.04v49.76c0,.57,.46,1.04,1.02,1.04h26.62c.56,0,1.02-.47,1.02-1.04v-49.76c0-.57-.46-1.04-1.02-1.04h0Zm-1.02,37.32h-24.57v-4.15h24.57v4.15h0Zm0-6.22h-24.57v-4.15h24.57v4.15h0Zm0-6.22h-24.57v-4.15h24.57v4.15h0Zm0-6.22h-24.57v-4.15h24.57v4.15h0Zm0-6.22h-24.57v-4.15h24.57v4.15h0Zm-24.57,26.95h24.57v4.15h-24.57v-4.15h0Zm0-37.32h24.57v4.15h-24.57v-4.15h0Zm0,47.68v-4.15h24.57v4.15h-24.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.48,128.37c-.56,0-1.02,.47-1.02,1.04v7.26h-7.17c-.56,0-1.02,.47-1.02,1.04s.46,1.04,1.02,1.04h8.19c.56,0,1.02-.47,1.02-1.04v-8.29c0-.57-.46-1.04-1.02-1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M167.22,137.7c0-.57-.46-1.04-1.02-1.04h-7.17v-7.26c0-.57-.46-1.04-1.02-1.04s-1.02,.47-1.02,1.04v8.29c0,.57,.46,1.04,1.02,1.04h8.19c.56,0,1.02-.47,1.02-1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M158,124.22c.56,0,1.02-.47,1.02-1.04v-7.26h7.17c.56,0,1.02-.47,1.02-1.04s-.46-1.04-1.02-1.04h-8.19c-.56,0-1.02,.47-1.02,1.04v8.29c0,.57,.46,1.04,1.02,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M178.48,113.86h-8.19c-.56,0-1.02,.47-1.02,1.04s.46,1.04,1.02,1.04h7.17v7.26c0,.57,.46,1.04,1.02,1.04s1.02-.47,1.02-1.04v-8.29c0-.57-.46-1.04-1.02-1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M192.81,103.49h-2.05c-.56,0-1.02,.47-1.02,1.04s.46,1.04,1.02,1.04h2.05c.56,0,1.02-.47,1.02-1.04s-.46-1.04-1.02-1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M190.76,111.79h2.05c.56,0,1.02-.47,1.02-1.04s-.46-1.04-1.02-1.04h-2.05c-.56,0-1.02,.47-1.02,1.04s.46,1.04,1.02,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M190.76,118h2.05c.56,0,1.02-.47,1.02-1.04s-.46-1.04-1.02-1.04h-2.05c-.56,0-1.02,.47-1.02,1.04s.46,1.04,1.02,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M190.76,124.22h2.05c.56,0,1.02-.47,1.02-1.04s-.46-1.04-1.02-1.04h-2.05c-.56,0-1.02,.47-1.02,1.04s.46,1.04,1.02,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M190.76,130.44h2.05c.56,0,1.02-.47,1.02-1.04s-.46-1.04-1.02-1.04h-2.05c-.56,0-1.02,.47-1.02,1.04s.46,1.04,1.02,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M190.76,136.66h2.05c.56,0,1.02-.47,1.02-1.04s-.46-1.04-1.02-1.04h-2.05c-.56,0-1.02,.47-1.02,1.04s.46,1.04,1.02,1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M192.81,140.81h-2.05c-.56,0-1.02,.47-1.02,1.04s.46,1.04,1.02,1.04h2.05c.56,0,1.02-.47,1.02-1.04s-.46-1.04-1.02-1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M192.81,147.03h-2.05c-.56,0-1.02,.47-1.02,1.04s.46,1.04,1.02,1.04h2.05c.56,0,1.02-.47,1.02-1.04s-.46-1.04-1.02-1.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M161.08,126.3c0,4,3.21,7.26,7.17,7.26s7.17-3.25,7.17-7.26-3.21-7.26-7.17-7.26-7.17,3.25-7.17,7.26h0Zm7.17-5.18c2.83,0,5.12,2.32,5.12,5.18s-2.29,5.18-5.12,5.18-5.12-2.32-5.12-5.18,2.29-5.18,5.12-5.18h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "147.97 77.28 154.91 77.28 154.91 80.52 147.97 80.52 147.97 77.28 147.97 77.28 147.97 77.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "154.91 77.28 161.84 77.28 161.84 80.52 154.91 80.52 154.91 77.28 154.91 77.28 154.91 77.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "161.84 77.28 168.78 77.28 168.78 80.52 161.84 80.52 161.84 77.28 161.84 77.28 161.84 77.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "168.78 77.28 175.7 77.28 175.7 80.52 168.78 80.52 168.78 77.28 168.78 77.28 168.78 77.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "175.7 77.28 182.64 77.28 182.64 80.52 175.7 80.52 175.7 77.28 175.7 77.28 175.7 77.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "182.64 77.28 189.57 77.28 189.57 80.52 182.64 80.52 182.64 77.28 182.64 77.28 182.64 77.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "189.57 77.28 196.5 77.28 196.5 80.52 189.57 80.52 189.57 77.28 189.57 77.28 189.57 77.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "196.5 77.28 203.43 77.28 203.43 80.52 196.5 80.52 196.5 77.28 196.5 77.28 196.5 77.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "203.43 77.28 210.37 77.28 210.37 80.52 203.43 80.52 203.43 77.28 203.43 77.28 203.43 77.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "210.37 77.28 217.3 77.28 217.3 80.52 210.37 80.52 210.37 77.28 210.37 77.28 210.37 77.28"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 154.91,
    y1: 77.23,
    x2: 154.91,
    y2: 80.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 161.84,
    y1: 77.23,
    x2: 161.84,
    y2: 80.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 168.78,
    y1: 77.23,
    x2: 168.78,
    y2: 80.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 175.7,
    y1: 77.23,
    x2: 175.7,
    y2: 80.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 182.64,
    y1: 77.23,
    x2: 182.64,
    y2: 80.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 189.57,
    y1: 77.23,
    x2: 189.57,
    y2: 80.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 196.5,
    y1: 77.23,
    x2: 196.5,
    y2: 80.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 203.43,
    y1: 77.23,
    x2: 203.43,
    y2: 80.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 210.37,
    y1: 77.23,
    x2: 210.37,
    y2: 80.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 147.97,
    y1: 77.23,
    x2: 147.97,
    y2: 80.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 217.3,
    y1: 77.23,
    x2: 217.3,
    y2: 80.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 147.92,
    y1: 77.28,
    x2: 217.36,
    y2: 77.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 147.92,
    y1: 80.52,
    x2: 217.36,
    y2: 80.52
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M307.6,106.79h-32.78c-.3,0-.51,.21-.51,.52s.25,.52,.51,.52h32.78c.3,0,.51-.21,.51-.52s-.2-.52-.51-.52h0Zm-32.78-5.58h21.54c.3,0,.51-.21,.51-.52s-.2-.52-.51-.52h-21.54c-.3,0-.51,.21-.51,.52s.25,.52,.51,.52h0Zm0-6.57h16.37c.3,0,.51-.21,.51-.52s-.2-.52-.51-.52h-16.37c-.3,0-.51,.21-.51,.52s.25,.52,.51,.52h0Zm32.78,12.15h-32.78c-.3,0-.51,.21-.51,.52s.25,.52,.51,.52h32.78c.3,0,.51-.21,.51-.52s-.2-.52-.51-.52h0Zm-32.78-5.58h21.54c.3,0,.51-.21,.51-.52s-.2-.52-.51-.52h-21.54c-.3,0-.51,.21-.51,.52s.25,.52,.51,.52h0Zm0-6.57h16.37c.3,0,.51-.21,.51-.52s-.2-.52-.51-.52h-16.37c-.3,0-.51,.21-.51,.52s.25,.52,.51,.52h0Zm32.78,12.15h-32.78c-.3,0-.51,.21-.51,.52s.25,.52,.51,.52h32.78c.3,0,.51-.21,.51-.52s-.2-.52-.51-.52h0Zm-11.25-6.62h-21.54c-.3,0-.51,.21-.51,.52s.25,.52,.51,.52h21.54c.3,0,.51-.21,.51-.52s-.2-.52-.51-.52h0Zm-5.17-6.57h-16.37c-.3,0-.51,.21-.51,.52s.25,.52,.51,.52h16.37c.3,0,.51-.21,.51-.52s-.2-.52-.51-.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M334.55,130.68c-.61-.83-1.77-.98-2.58-.36-.35,.26-.56,.62-.66,.98h-8.46v-3.05h1.57c.76,0,1.42-.67,1.42-1.45v-.05h2.84c.05,.21,.15,.41,.3,.62,.61,.83,1.77,.98,2.58,.36,.81-.62,.96-1.81,.35-2.64-.61-.83-1.77-.98-2.58-.36-.35,.26-.56,.62-.66,.98h-2.84v-1.5l1.37-1.03c1.06,.62,2.33,.1,2.69-1.03,.3-.98-.2-2.02-1.17-2.38-.96-.31-1.98,.21-2.33,1.19-.15,.47-.1,.98,.1,1.45l-1.47,1.09c-.1,.1-.2,.26-.2,.41v2.84c0,.26-.2,.41-.41,.41h-1.57v-2.59c0-.98-.76-1.81-1.77-1.81h-.91v-7.6c0-1.4-1.11-2.53-2.48-2.53h-5.68v-14.58c0-.1-.05-.26-.15-.36-8.21-8.35-10-10.19-10.3-10.5l.03,.02s-.04-.04-.07-.07c-.1-.05-.25-.15-.35-.15h-26.35c-2.38,0-4.36,2.02-4.36,4.45v44.88c0,2.48,1.98,4.45,4.36,4.45h32.13v1.65c0,.21-.2,.41-.41,.41h-2.79c-.15,0-.3,.05-.41,.21l-1.11,1.5c-.25-.15-.56-.21-.91-.21-1.01,.05-1.82,.88-1.77,1.96,.05,1.03,.91,1.86,1.93,1.81,1.01-.05,1.82-.88,1.77-1.91,0-.31-.1-.62-.25-.88l1.01-1.4h1.47v2.9c-.2,.05-.41,.16-.61,.31-.81,.62-.96,1.81-.35,2.64,.61,.83,1.77,.98,2.58,.36s.96-1.81,.35-2.64c-.25-.31-.61-.57-.96-.67v-2.9h.05c.76,0,1.42-.62,1.42-1.45v-1.71h2.99v8.74c-.2,.05-.41,.15-.61,.31-.81,.62-.96,1.81-.35,2.64,.61,.83,1.77,.98,2.58,.36,.81-.62,.96-1.81,.35-2.64-.25-.31-.56-.57-.96-.67v-8.74h2.99v1.65c0,.78,.66,1.45,1.42,1.45h.05v2.9c-.2,.05-.41,.16-.61,.31-.81,.62-.96,1.81-.35,2.64,.61,.83,1.77,.98,2.58,.36,.81-.62,.96-1.81,.35-2.64-.25-.31-.56-.57-.96-.67v-2.9h1.47l1.01,1.4c-.05,.1-.15,.26-.15,.36-.3,.98,.2,2.02,1.17,2.38,.96,.31,1.98-.21,2.33-1.19,.3-.98-.2-2.02-1.17-2.38-.46-.16-.96-.1-1.42,.1l-1.06-1.5c-.1-.16-.25-.21-.41-.21h-2.79c-.2,0-.41-.21-.41-.41v-1.65h5.12c.96,0,1.77-.78,1.77-1.81v-2.59h1.52c.25,0,.41,.21,.41,.41v2.84c0,.16,.1,.31,.2,.41l1.52,1.14c-.15,.26-.2,.57-.2,.88,.05,1.03,.86,1.81,1.82,1.81,1.06,0,1.87-.88,1.82-1.97-.05-1.03-.91-1.86-1.87-1.81-.3,0-.61,.1-.86,.26l-1.37-1.03v-1.5h2.84c.05,.21,.15,.41,.3,.62,.61,.83,1.77,.98,2.58,.36,.81-.62,.96-1.81,.35-2.64-.61-.83-1.77-.98-2.58-.36-.3,.26-.56,.57-.66,.98h-2.84v-.05c0-.78-.61-1.45-1.42-1.45h-1.52v-3.1h8.46c.05,.21,.15,.41,.3,.62,.61,.83,1.77,.98,2.58,.36,.71-.52,.86-1.66,.25-2.48h0Zm-18.75-13.5v5.64h-3.8v-5.64h3.8Zm-4.81,0v5.64h-3.8v-5.64h3.8Zm-36.18,10.39h25.28v5.58h-25.28c-.3,0-.51,.21-.51,.52s.2,.52,.51,.52h25.28v4.81c0,.26,.05,.52,.15,.78h-25.44c-1.82-.05-3.34-1.55-3.34-3.46v-44.88c0-1.86,1.52-3.41,3.34-3.41h25.84v7.55c0,1.65,1.32,3,2.94,3h7.4v14.06h-5.78c-.66,0-1.27,.26-1.72,.72h-28.68c-.3,0-.51,.21-.51,.52s.25,.52,.51,.52h28.07c-.1,.26-.15,.52-.15,.78v4.81h-27.92c-.3,0-.51,.21-.51,.52,0,.26,.25,.52,.51,.52h27.92v1.76h-.86c-.96,0-1.77,.78-1.77,1.81v1.97h-25.28c-.3,0-.51,.21-.51,.52s.2,.52,.51,.52h0Zm47.02,8.22h-20.72v-11.22c0-.41,.35-.78,.76-.78h19.26c.41,.05,.71,.36,.71,.78v11.22Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M425.9,91.07h-36.74v28.79c0,.57-.46,1.04-1.03,1.04s-1.03-.47-1.03-1.04v-29.83c0-.57,.46-1.04,1.03-1.04h38.79c.27,0,.53,.11,.73,.3l7.5,7.59c.19,.2,.3,.46,.3,.74v53.16c0,.57-.46,1.04-1.03,1.04h-40.69c-.57,0-1.03-.47-1.03-1.04s.46-1.04,1.03-1.04h39.66v-51.08h-6.47c-.57,0-1.03-.47-1.03-1.04v-6.55Zm6.05,5.51l-3.99-4.04v4.04h3.99Zm-40.61,47.18c0,3.92,0,8.23,0,8.3,.03,.3-.06,.59-.25,.81-.2,.22-.47,.35-.77,.35h-10.63c-.56,0-1.01-.45-1.03-1.01,0-.13,0-14.8,0-14.8,0-2.67,1.62-4.97,3.91-5.92-1.79-.91-3.02-2.78-3.02-4.94,0-3.04,2.45-5.52,5.45-5.52s5.45,2.48,5.45,5.52c0,2.16-1.24,4.04-3.04,4.95,2.01,.84,3.5,2.69,3.84,4.94l1.09,.72h10.22c1.8,0,3.26,1.48,3.26,3.3,0,.71-.22,1.36-.59,1.9h3.63s.06-.03,.06-.06v-12.08c0-.44,.17-.86,.48-1.17,.31-.31,.72-.48,1.15-.48h2.94c.43,0,.85,.17,1.15,.48,.31,.31,.48,.73,.48,1.17v13.72c0,1.09-.43,2.13-1.18,2.9-.76,.77-1.79,1.2-2.86,1.2h-12.94c-.43,0-.85-.17-1.15-.48-.31-.31-.48-.73-.48-1.17v-2.37c0-.08,0-.16,.02-.24h-5.14s-.04,0-.07,0h0Zm-3.22-9.31c-.79-.84-1.9-1.36-3.14-1.36-2.34,0-4.25,1.94-4.25,4.32h0s0,10.4,0,13.73h8.57c0-1.74-.01-5.15-.01-8.14-1.07-.7-4.14-2.71-4.14-2.71-1.51-.98-1.95-3.03-.98-4.56,0,0,0,0,0,0,.87-1.35,2.53-1.85,3.95-1.28h0Zm3.29,7.23h11.17c.67,0,1.21-.55,1.21-1.22s-.54-1.22-1.21-1.22h-10.52c-.2,0-.39-.06-.56-.17l-3.94-2.58c-.56-.36-1.3-.19-1.67,.38-.35,.57-.19,1.32,.37,1.68,0,0,0,0,0,0,0,0,4.5,2.94,4.5,2.94,.2,.12,.42,.19,.64,.19h0Zm-6.39-11.69c1.88,0,3.39-1.55,3.39-3.44s-1.52-3.44-3.39-3.44-3.39,1.55-3.39,3.44,1.53,3.44,3.39,3.44h0Zm13.56,15.95h12.52c.53,0,1.03-.21,1.41-.59,.37-.38,.58-.89,.58-1.42v-13.29h-2.09v11.65c0,1.18-.95,2.14-2.11,2.14h-10.3v1.51h0Zm-.99-36.08c-.57,0-1.03-.47-1.03-1.04s.46-1.04,1.03-1.04h27.4c.57,0,1.03,.47,1.03,1.04s-.46,1.04-1.03,1.04h-27.4Zm0,8.17c-.57,0-1.03-.47-1.03-1.04s.46-1.04,1.03-1.04h27.4c.57,0,1.03,.47,1.03,1.04s-.46,1.04-1.03,1.04h-27.4Zm0-16.35c-.57,0-1.03-.47-1.03-1.04s.46-1.04,1.03-1.04h19.67c.57,0,1.03,.47,1.03,1.04s-.46,1.04-1.03,1.04h-19.67Zm2.85,19.62c3.93,0,7.12,3.23,7.12,7.21s-3.19,7.21-7.12,7.21-7.12-3.23-7.12-7.21,3.19-7.21,7.12-7.21h0Zm0,2.08c-2.8,0-5.07,2.3-5.07,5.13s2.27,5.13,5.07,5.13,5.07-2.3,5.07-5.13-2.27-5.13-5.07-5.13h0Zm-3.8,6.13c-.4-.41-.4-1.07,0-1.47,.4-.41,1.05-.41,1.45,0l1.48,1.5,3.21-3.27c.4-.41,1.05-.41,1.45,0,.4,.4,.4,1.06,0,1.47l-3.94,4.01c-.19,.2-.45,.31-.73,.31-.27,0-.54-.11-.73-.3l-2.21-2.24Zm28.32-8.21c3.93,0,7.12,3.23,7.12,7.21s-3.19,7.21-7.12,7.21-7.12-3.23-7.12-7.21,3.19-7.21,7.12-7.21h0Zm0,2.08c-2.8,0-5.07,2.3-5.07,5.13s2.27,5.13,5.07,5.13,5.07-2.3,5.07-5.13-2.27-5.13-5.07-5.13h0Zm-1.45,5.13l-1.54-1.56c-.4-.41-.4-1.07,0-1.47,.4-.41,1.05-.41,1.45,0l1.54,1.56,1.54-1.56c.4-.41,1.05-.41,1.45,0s.4,1.07,0,1.47l-1.54,1.56,1.54,1.56c.4,.41,.4,1.07,0,1.47-.4,.41-1.05,.41-1.45,0l-1.54-1.56-1.54,1.56c-.4,.41-1.05,.41-1.45,0-.4-.41-.4-1.07,0-1.47l1.54-1.56Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M520.32,101.45c-10.43,0-18.91,8.59-18.91,19.15s8.48,19.15,18.91,19.15,18.91-8.59,18.91-19.15-8.48-19.15-18.91-19.15h0Zm0,36.48c-9.44,0-17.12-7.78-17.12-17.33s7.68-17.33,17.12-17.33,17.12,7.78,17.12,17.33-7.68,17.33-17.12,17.33h0Zm31.04-22.07l-6.77-2.65c-.49-1.66-1.15-3.26-1.95-4.77l2.93-6.72c.15-.34,.08-.74-.19-1.01l-5.43-5.5c-.26-.26-.66-.34-1-.19l-6.64,2.97c-1.5-.82-3.08-1.48-4.71-1.98l-2.62-6.85c-.13-.35-.47-.58-.84-.58h-7.68c-.37,0-.7,.23-.84,.58l-2.62,6.85c-1.64,.5-3.22,1.16-4.71,1.98l-6.64-2.97c-.34-.15-.73-.08-1,.19l-5.43,5.5c-.26,.26-.34,.67-.19,1.01l2.93,6.72c-.81,1.52-1.46,3.12-1.95,4.78l-6.77,2.65c-.35,.13-.57,.47-.57,.85v7.77c0,.37,.23,.71,.57,.85l6.77,2.65c.49,1.65,1.14,3.25,1.95,4.77l-2.93,6.72c-.15,.34-.08,.74,.19,1.01l5.43,5.5c.26,.26,.66,.34,1,.19l6.64-2.97c1.5,.82,3.08,1.48,4.71,1.98l2.62,6.85c.13,.35,.47,.58,.84,.58h7.68c.37,0,.7-.23,.84-.58l2.62-6.85c1.63-.5,3.21-1.16,4.71-1.98l6.64,2.97c.34,.15,.73,.08,1-.19l5.43-5.5c.26-.26,.34-.67,.19-1.01l-2.93-6.72c.81-1.52,1.46-3.12,1.95-4.77l6.77-2.65c.35-.13,.57-.47,.57-.85v-7.77c0-.37-.23-.71-.57-.85h0Zm-1.22,7.99l-6.61,2.59c-.26,.1-.46,.33-.54,.6-.51,1.82-1.22,3.57-2.13,5.22-.14,.25-.15,.55-.04,.81l2.86,6.56-4.56,4.62-6.48-2.9c-.26-.12-.56-.1-.8,.04-1.62,.92-3.36,1.65-5.15,2.16-.27,.08-.49,.28-.59,.55l-2.56,6.69h-6.45l-2.55-6.69c-.1-.27-.32-.47-.59-.55-1.8-.51-3.53-1.24-5.15-2.16-.25-.14-.54-.16-.8-.04l-6.48,2.9-4.56-4.62,2.86-6.56c.11-.26,.1-.56-.04-.81-.91-1.65-1.63-3.41-2.14-5.21-.08-.27-.28-.5-.54-.6l-6.61-2.59v-6.53l6.61-2.59c.26-.1,.46-.33,.54-.6,.5-1.82,1.22-3.57,2.13-5.22,.14-.25,.15-.55,.04-.81l-2.86-6.56,4.56-4.62,6.48,2.9c.26,.12,.56,.1,.8-.04,1.62-.92,3.35-1.65,5.15-2.16,.27-.08,.49-.28,.59-.55l2.55-6.69h6.45l2.56,6.69c.1,.27,.32,.47,.59,.55,1.79,.51,3.53,1.24,5.15,2.16,.25,.14,.54,.15,.8,.04l6.48-2.9,4.56,4.62-2.86,6.56c-.11,.26-.1,.56,.04,.81,.91,1.64,1.63,3.39,2.13,5.21,.08,.27,.28,.5,.54,.6l6.61,2.59v6.53h0Zm-18.24-12.63l-1.44,.84c-.97-1.18-2.13-2.18-3.43-2.96l1.02-1.79c.25-.43,.1-.99-.33-1.24-.43-.25-.98-.1-1.22,.33l-1.07,1.88c-1.31-.56-2.72-.91-4.2-1.01v-2.3c0-.5-.4-.91-.9-.91s-.9,.41-.9,.91v2.3c-1.48,.1-2.89,.45-4.2,1.01l-1.07-1.88c-.25-.43-.79-.58-1.22-.33-.43,.25-.58,.8-.33,1.24l1.02,1.79c-1.31,.78-2.47,1.79-3.43,2.96l-1.44-.84c-.43-.25-.98-.1-1.22,.33s-.1,.99,.33,1.24l1.28,.75c-.85,1.38-1.46,2.93-1.77,4.59h-.93c-.5,0-.9,.41-.9,.91s.4,.91,.9,.91h.72c-.01,.21-.02,.43-.02,.64,0,4.68,2.39,8.79,5.99,11.18,.05,.04,.1,.07,.15,.1,2.04,1.31,4.45,2.07,7.04,2.07s5.02-.76,7.06-2.08c.04-.02,.08-.05,.11-.08,3.61-2.38,6.01-6.51,6.01-11.19,0-.22,0-.43-.02-.64h.72c.5,0,.9-.41,.9-.91s-.4-.91-.9-.91h-.93c-.31-1.66-.91-3.21-1.77-4.59l1.28-.75c.43-.25,.58-.81,.33-1.24-.25-.43-.79-.58-1.22-.33h0Zm-11.58,14.33c-1.1,0-2-.91-2-2.03s.9-2.03,2-2.03,2.01,.91,2.01,2.03-.9,2.03-2.01,2.03h0Zm-11.39-4.97c0-.22,0-.43,.02-.64h2.37c.5,0,.9-.41,.9-.91s-.4-.91-.9-.91h-2.13c.29-1.33,.8-2.57,1.49-3.68l1.39,.81c.14,.08,.3,.12,.45,.12,.31,0,.61-.16,.78-.45,.25-.43,.1-.99-.33-1.24l-1.21-.71c.79-.91,1.72-1.69,2.75-2.32l.53,.93c.17,.29,.47,.45,.78,.45,.15,0,.31-.04,.45-.12,.43-.25,.58-.8,.33-1.24l-.47-.82c1.03-.42,2.14-.68,3.3-.77v10.7c-1.66,.41-2.9,1.93-2.9,3.74,0,.98,.37,1.88,.97,2.56-1.74,.67-3.22,1.94-4.15,3.61-2.68-2.11-4.41-5.41-4.41-9.11h0Zm5.91,10.1c1.07-2.02,3.19-3.33,5.48-3.33s4.41,1.31,5.48,3.33c-1.63,.91-3.49,1.43-5.48,1.43s-3.85-.52-5.48-1.43h0Zm16.61-12.57h-2.13c-.5,0-.9,.41-.9,.91s.4,.91,.9,.91h2.37c.01,.21,.02,.43,.02,.64,0,3.7-1.73,7-4.41,9.11-.93-1.66-2.41-2.94-4.15-3.61,.6-.68,.97-1.58,.97-2.56,0-1.81-1.24-3.33-2.9-3.74v-10.7c1.16,.09,2.26,.36,3.3,.77l-.47,.82c-.25,.43-.1,.99,.33,1.24,.14,.08,.29,.12,.45,.12,.31,0,.61-.16,.78-.45l.53-.93c1.03,.62,1.96,1.41,2.75,2.32l-1.21,.71c-.43,.25-.58,.81-.33,1.24,.17,.29,.47,.45,.78,.45,.15,0,.31-.04,.45-.12l1.39-.82c.69,1.11,1.21,2.35,1.49,3.68h0Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "568.92 55.54 633.38 55.54 640.94 63.26 633.38 70.98 586.2 70.98 586.2 184.11 568.92 184.11 568.92 184.11 473.34 184.11 473.34 168.58 568.92 168.58 568.92 61.49 568.92 61.49 568.92 55.54 568.92 55.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "361.61 55.54 473.13 55.54 473.13 63.2 473.13 63.2 473.13 168.69 521.64 168.69 529.2 176.35 521.64 184.01 473.13 184.01 473.13 184.11 457.18 184.11 457.18 184.01 457.18 168.69 457.18 70.97 361.61 70.97 361.61 55.54 361.61 55.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "342.91 55.54 407.37 55.54 414.93 63.26 407.37 70.98 360.2 70.98 360.2 184.11 342.91 184.11 342.91 184.11 247.33 184.11 247.33 168.58 342.91 168.58 342.91 61.49 342.91 61.49 342.91 55.54 342.91 55.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.62 55.54 248.14 55.54 248.14 63.2 248.14 63.2 248.14 168.69 296.66 168.69 304.22 176.35 296.66 184.01 248.14 184.01 248.14 184.11 232.2 184.11 232.2 184.01 232.2 168.69 232.2 70.97 136.62 70.97 136.62 55.54 136.62 55.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "118.94 55.54 183.4 55.54 190.96 63.23 183.4 70.92 136.22 70.92 136.22 183.6 118.94 183.6 118.94 183.6 23.36 183.6 23.36 168.13 118.94 168.13 118.94 61.47 118.94 61.47 118.94 55.54 118.94 55.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.6 70.46 22.57 70.46 22.57 168.16 71.1 168.16 78.72 175.88 71.1 183.6 22.57 183.6 6.6 183.6 6.6 168.16 6.6 70.46 6.6 70.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "640.94 243.77 640.94 0 0 0 0 243.77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcmPath);
export default __webpack_public_path__ + "static/media/RcmPath.b52decb6272a0d4cbf2f84c4afe3c939.svg";
export { ForwardRef as ReactComponent };